function TwoUpRows(el) {
  function inViewPort() {
    var rect = el.getBoundingClientRect();
    return ( rect.top - innerHeight < 0 ) && ( ( rect.top + rect.height ) > 0 );
  }
  window.addEventListener('scroll', function () {
    if( inViewPort() ) {
      el.classList.add('two-up-rows--animate');
    }
  })
}

module.exports = TwoUpRows;
